<template>
  <div class="photo-identity">
    <slot name="ready" v-if="isReady"></slot>
    <camera-player
      @take="onTake"
      v-if="cameraEnable"
      :facing-mode="setting.facingMode"
    />
    <canvas ref="preview" v-show="isPreview"></canvas>
    <button
      :class="buttonClass"
      @click.prevent="onCameraEnable"
      v-show="!cameraEnable"
    >
      {{ buttonText }}
    </button>
    <input
      type="hidden"
      :value="uploadedFileValue"
      :name="setting.name"
      v-if="uploadedFileValue.length > 0"
    />
  </div>
</template>

<script>
import 'blueimp-canvas-to-blob';
import { DirectUpload } from '@rails/activestorage';
import CameraPlayer from '../components/CameraPlayer.vue';
import { resizeCanvas } from '../lib/image';

export default {
  name: 'PhotoIdentity',
  components: {
    CameraPlayer,
  },
  props: {
    setting: {
      type: Object,
      default: function () {
        return {
          directUploadUrl: '',
          name: '',
          facingMode: 'environment',
          maxWidth: 1980, // 追加：最大幅
          maxHeight: 1980, // 追加：最大高さ
          quality: 0.95, // 追加：JPEG品質
        };
      },
    },
  },
  data() {
    return {
      cameraEnable: false,
      photoTaken: false,
      uploadedFileValue: '',
    };
  },
  computed: {
    isReady() {
      return !this.cameraEnable && !this.photoTaken;
    },
    isPreview() {
      return !this.cameraEnable && this.photoTaken;
    },
    buttonText() {
      if (this.isPreview) {
        return '撮影しなおす';
      }

      return '撮影する';
    },
    buttonClass() {
      if (this.isPreview) {
        return 'btn btn-warning';
      }

      return 'bnt btn-primary';
    },
  },
  methods: {
    onCameraEnable() {
      this.cameraEnable = true;
    },
    onTake(video) {
      this.cameraEnable = false;
      this.photoTaken = true;
      const canvas = this.$refs.preview;
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      canvas
        .getContext('2d')
        .drawImage(video, 0, 0, video.videoWidth, video.videoHeight);
      this.uploadedFileValue = '';
      this.$emit('uploading');

      // リサイズしたキャンバスを使用
      const maxWidth = this.setting.maxWidth || 1980;
      const maxHeight = this.setting.maxHeight || 1980;
      const resizedCanvas = resizeCanvas(canvas, maxWidth, maxHeight);
      this.upload(resizedCanvas);
    },
    upload(canvas) {
      canvas.toBlob(
        (blob) => {
          if (!blob) {
            throw new Error('Blob is null');
          }
          blob.name = `${new Date().getTime()}.jpg`;
          const upload = new DirectUpload(blob, this.setting.directUploadUrl);
          upload.create((error, blob) => {
            if (error) {
              console.error('DirectUpload failed:', error);
              this.photoTaken = false;
              this.$emit('upload-failed', { error });
              return;
            }

            this.uploadedFileValue = blob.signed_id;
            this.$emit('attached');
          });
        },
        'image/jpeg',
        this.setting.quality || 0.95 // 品質パラメータを使用
      );
    },
  },
};
</script>

<style scoped lang="scss">
.photo-identity {
  canvas {
    max-width: 100%;
    height: auto;
    display: block;
    margin: auto auto 1rem;
  }
}
</style>
